import { render } from "./consultaInventario.vue?vue&type=template&id=5c44fef2&scoped=true"
import script from "./consultaInventario.vue?vue&type=script&lang=js"
export * from "./consultaInventario.vue?vue&type=script&lang=js"

import "./consultaInventario.vue?vue&type=style&index=0&id=5c44fef2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c44fef2"]])

export default __exports__